import API from 'services/API';

export default function getSiteMap() {
  return API.request({
    method: 'GET',
    url: '/siteMap',
  });
}
